import React from 'react'
import { Image as ImageDisplay } from '@morningtrain/react-displays'
import WhenOnScreen from 'support/conditionals/WhenOnScreen'
import { useValue } from '@morningtrain/react-resources'

export default function Image (props) {
  const value = useValue(props.name, props.defaultValue)

  if (props.lazy) {
    return (
      <WhenOnScreen once>
        <ImageDisplay key={value} {...props} />
      </WhenOnScreen>
    )
  }

  return <ImageDisplay key={value} {...props} />
}

Image.defaultProps = {
  ...ImageDisplay.defaultProps
}

Image.propTypes = {
  ...ImageDisplay.propTypes
}
